module.exports = __webpack_public_path__ + "img/fashion_92.5721e3b7.jpg";